// const Types = {};

export const state = {};

export const getters = {};

export const mutations = {};

export const actions = {
  addToCart: (context, { product, vm }) => {
    vm.$gtm.addToCart([{ ...product }]);
  },
  removeFromCart: (context, { product, vm }) => {
    vm.$gtm.removeFromCart([...product]);
  },
};
